import { usePageContext } from "vike-react/usePageContext";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import SeoHreflang from "@/components/SeoHreflang";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import type { Language } from "@/i18n/translations";

export default function Layout({ children }: { children: React.ReactNode }) {
  const pageContext = usePageContext();
  const { setLanguage, language } = useLanguage();

  useEffect(() => {
    const pathname = pageContext.urlPathname;
    const langMatch = pathname.match(/^\/(pl|en|de)(\/|$)/);
    const lang = langMatch ? (langMatch[1] as Language) : null;

    if (lang && ["pl", "en", "de"].includes(lang) && lang !== language) {
      setLanguage(lang);
    }
  }, [pageContext.urlPathname, language, setLanguage]);

  return (
    <div className="min-h-screen">
      <GoogleAnalytics />
      <SeoHreflang />
      <ScrollToTop />
      <Header />
      <main>
        {children}
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
